var map = {
	"./logo-chat-sm.svg": 70584,
	"./promo.svg": 30670,
	"./site-logo-desktop-footer.svg": 46725,
	"./site-logo-desktop.svg": 36371,
	"./site-logo-drawer-mobile.svg": 79613,
	"./site-logo-drawer.svg": 59518,
	"./site-logo-mobile-drawer.svg": 96783,
	"./site-logo-mobile.svg": 63239,
	"./site-logo-sm.svg": 91997,
	"./site-logo-tv.svg": 61355,
	"./site-logo-wrapper-mobile-scrolled.svg": 93101,
	"./site-logo-wrapper-mobile.svg": 64853,
	"./site-logo-wrapper-scrolled.svg": 26087,
	"./site-logo-wrapper.svg": 25398
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 69231;